import FormatColorFill  from '@material-ui/icons/FormatColorFill';
import FormatColorText from '@material-ui/icons/FormatColorText';

const controls = {
    textColor: {
        icon: FormatColorText,
        value: 'color',
    },
    backgroundColor: {
        icon: FormatColorFill,
        value: 'bgcolor',
    }
};

export const COLOR_PICKERS = [
    controls.textColor,
    controls.backgroundColor
];